export default "__VITE_ASSET__B3GfIbSY__"